export default "__VITE_ASSET__CAbVhoBr__"